import React from 'react';
import { Button, Icon } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { sortedHumanSizes } from '../../config/utils';

const AddToCanvasButtons = ({
  workSizesAttributes, landscape, addToCanvas
}) => sortedHumanSizes(workSizesAttributes, landscape).map(([hs, ws]) => (
  <Button
    key={ hs }
    size="mini"
    onClick={ () => addToCanvas(ws.id, ws.paperWidth, ws.paperHeight) }
  >
    { ws.isHidden ? <Icon name="eye slash" /> : null }
    { hs }
  </Button>
));

AddToCanvasButtons.propTypes = {
  addToCanvas: PropTypes.func.isRequired,
  landscape: PropTypes.bool.isRequired,
  workSizesAttributes: PropTypes.arrayOf(PropTypes.shape({
    paperWidth: PropTypes.number.isRequired,
    paperHeight: PropTypes.number.isRequired,
    id: PropTypes.number.isRequired
  })).isRequired
};

export default AddToCanvasButtons;
